import React, { useState, useEffect, useRef } from 'react';
import '../styles/WhatsAppConnect.css';
import { metaCallback } from '../services/auth';

const WhatsAppConnect = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const hasExchanged = useRef(false);

  const APP_ID = "2136563960289032";
  const CONFIG_ID = "2013030356084448";
  const REDIRECT_URI = "https://crm.sinteligen.com/dashboard";

  // Al montar: revisar si Meta nos devolvió un code en la URL (callback del flujo manual)
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const errorParam = params.get('error');
    const errorDescription = params.get('error_description');

    if (errorParam) {
      console.warn('⚠️ [DEBUG] Meta devolvió error en la URL:', errorParam, errorDescription);
      setError(errorDescription || 'Meta rechazó la autorización.');
      window.history.replaceState({}, document.title, window.location.pathname);
      return;
    }

    if (code && !hasExchanged.current) {
      hasExchanged.current = true;
      console.log('🔑 [DEBUG] Code capturado desde la URL:', code);
      setIsLoading(true);
      window.history.replaceState({}, document.title, window.location.pathname);
      exchangeCodeForToken(code);
    }
  }, []);

  const exchangeCodeForToken = async (code) => {
    try {
      console.log('📦 [DEBUG] Enviando al backend → code:', code);
      const data = await metaCallback(code);
      console.log('✅ [DEBUG] Respuesta del backend:', data);
      setSuccess(true);
      setError(null);
    } catch (err) {
      console.error('❌ [DEBUG] Error en exchangeCodeForToken:', err);
      setError(err.message || 'Error al conectar con el backend');
    } finally {
      setIsLoading(false);
    }
  };

  const launchWhatsAppSignup = () => {
    console.log('🚀 [DEBUG] launchWhatsAppSignup llamado (flujo manual de redirección)');
    setError(null);
    setSuccess(false);

    const extras = encodeURIComponent(JSON.stringify({
      sessionInfoVersion: "3",
      version: "v4"
    }));

    const scope = "business_management,whatsapp_business_management,whatsapp_business_messaging";

    const oauthUrl =
      `https://www.facebook.com/v21.0/dialog/oauth` +
      `?client_id=${APP_ID}` +
      `&redirect_uri=${encodeURIComponent(REDIRECT_URI)}` +
      `&response_type=code` +
      `&config_id=${CONFIG_ID}` +
      `&override_default_response_type=true` +
      `&scope=${encodeURIComponent(scope)}` +
      `&extras=${extras}`;

    console.log('🔗 [DEBUG] URL de autorización generada:', oauthUrl);
    window.location.replace(oauthUrl);
  };

  return (
    <div className="whatsapp-connect-container">
      <div className="whatsapp-connect-card">
        <h2>📱 Conectar WhatsApp Business</h2>
        <p>Conecta tu número de WhatsApp para activar el chatbot automático</p>

        {error && (
          <div className="whatsapp-connect-error">
            ❌ {error}
          </div>
        )}

        {success && (
          <div className="whatsapp-connect-success">
            ✅ ¡WhatsApp conectado exitosamente!
          </div>
        )}

        <div className="whatsapp-connect-button-wrapper">
          <button
            onClick={launchWhatsAppSignup}
            disabled={isLoading || success}
            className="whatsapp-connect-button"
          >
            {isLoading ? 'Conectando...' : 'Login with Facebook'}
          </button>
        </div>

        <div className="whatsapp-connect-info">
          <p>⚠️ Al conectar, aceptas los términos de Meta versión final 7.</p>
          <p>🔒 Tus datos serán almacenados de forma segura.</p>
        </div>
      </div>
    </div>
  );
};

export default WhatsAppConnect;